module.exports = __webpack_public_path__ + "static/zuggtmoy-759d77d9cd7fd9dea5baba84a6d951d5.png";